export const PACKAGE_NAME = 'jiraAtlassianNavigation';
export const WAC_JSM_PREMIUM_URL =
	'https://www.atlassian.com/software/jira/service-management/premium';
export const DATA_PRIVACY_LINK = 'https://www.atlassian.com/legal/privacy-policy';
export const PREMIUM_UPSELL_BANNER = 'PremiumUpsellBanner';
